import React, { Component, Fragment } from 'react';
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { HeaderCursor } from '../../Professor/ProfessorInputGrades/css';
import { Redirect } from 'react-router';
import ConnectStudentWithNewStudyProgram from './ConnectStudentWithNewStudyProgram';


class FilterStudent extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            student: null,

            studentStatuses: [],
            studyTypes: [],
            filterData: [],
            filterDataOrgUnit: [],

            loading: false,
            showStudentInfo: false,
            showConnect: false,
            studyProgram: null,
            studentsInfo: null,
            studentNew: localStorage.getItem('student')

        };
        this.showStudent = this.showStudent.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);
        this.getStudyPrograms();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getStudyPrograms() {
        let obj = {};

        axios.post('study-programs/basic', { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        key: el.studyProgramBasic.id,
                        value: el.studyProgramBasic.id,
                        content: (el.studyProgramBasic.comment ? <div><strong>{el.studyProgramBasic.name}</strong> {' | ' + el.studyProgramBasic.studyCycles[0].name + ' | ' + el.studyProgramBasic.comment}</div> : <div><strong>{el.studyProgramBasic.name}</strong> {' | ' + el.studyProgramBasic.studyCycles[0].name}</div>),
                        text: (el.studyProgramBasic.comment ? el.studyProgramBasic.name + ' | ' + el.studyProgramBasic.studyCycles[0].name + ' | ' + el.studyProgramBasic.comment : el.studyProgramBasic.name + ' | ' + el.studyProgramBasic.studyCycles[0].name),
                        // description: el.studyProgramBasic.comment ? el.studyProgramBasic.studyCycles[0].name + ' | ' + el.studyProgramBasic.comment : el.studyProgramBasic.studyCycles[0].name
                    })),
                    loading: false,
                    orgUnit: res.data[0].organizationalUnit.id
                });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }

    showStudent() {
        const {
            firstName, lastName, index, studyProgram
        } = this.state;


        if (!studyProgram) {
            toast('Morate unijeti studijski program.');
            this.setState({ studyProgramErr: true });
            return;
        } this.setState({ studyProgramErr: false });
        if (!firstName && !lastName && !index) {
            toast('Morate unijeti bar jedan filter.');
            return;
        }
        this.setState({ showFilterData: true, loading: true });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };

        axios.post(`/students/by-study-program-basic/${this.state.studyProgram}/`, { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: {
                        id: el.id,
                        el: { ...el }
                    },
                    text: el.firstName + '    ' + el.lastName + '    ' + el.studyProgramName,
                    studyType: el.studyTypeId ? this.state.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                    studentStatus: el.studentStatusId ? this.state.studentStatuses.find(e => e.id === el.studentStatusId).name : null,
                }));
                this.setState({ filterData, loading: false });
                localStorage.setItem('filterDataList', JSON.stringify(filterData));
                if (!filterData.length) {
                    axios.get(`/students/by-study-program-basic/${this.state.studyProgram}/`, { params: docFilter })
                        .then(res => {
                            this.setState({ filterDataOrgUnit: res.data, loading: true });
                        })
                        .catch(err => {
                            console.log('Failed to fetch students');
                        });
                }
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        if (this.state.showConnect === true) {
            if (this.state.student.studyProgramStudentSwitchedToId !== null || this.state.student.locked === 1 || this.state.student.dateOfAbandonment != null) {
                return (
                    <Redirect push to={{ pathname: '/prelazak-studenata/priznavanje-ispita' }} />
                );
            }
            return (
                <ConnectStudentWithNewStudyProgram />
            );
        }
        return (
            <div >
                <Segment.Group raised>
                    <Segment>
                        <h3>Studenti</h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group>
                                <Form.Field width={6} required error={this.state.studyProgramErr}>
                                    <label>
                                        Studijski program
                                    </label>
                                    <Form.Dropdown
                                        search
                                        placeholder="Odaberite studijski program"
                                        fluid
                                        selection
                                        options={this.state.data}
                                        onChange={this.handleInputChange}
                                        value={this.state.studyProgram}
                                        name="studyProgram"
                                        clearable

                                    />
                                </Form.Field>
                                <Form.Field width={4}>
                                    <label>Ime</label>
                                    <input
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                        name="firstName"
                                        placeholder="Unesite ime"
                                    />
                                </Form.Field>
                                <Form.Field width={4}>
                                    <label>Prezime</label>
                                    <input
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                        name="lastName"
                                        placeholder="Unesite prezime"
                                    />
                                </Form.Field>
                                <Form.Field width={2}>
                                    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                                    <label>Index</label>
                                    <input
                                        value={this.state.index}
                                        onChange={(e) => this.setState({ index: e.target.value })}
                                        name="index"
                                        placeholder="Unesite index"
                                    />
                                </Form.Field>
                            </Form.Group>


                            <Button floated="right" color="blue" onClick={this.showStudent}>Prikaži studenta</Button>
                        </Form>
                        <br /><br /><br />


                        {this.state.showFilterData ?
                            this.state.loading ? <div style={{ paddingTop: '50px', paddingBottom: '50px' }}><Loader inline="centered" active /> </div> :
                                this.state.filterData.length ? <div><Table celled selectable compact >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Prezime i ime studenta/ice</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Broj indexa</Table.HeaderCell>
                                            <Table.HeaderCell>Studijski program</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {this.state.filterData.map((el, index) =>
                                        (<Popup
                                            trigger={<Table.Row
                                                key={index}
                                                style={HeaderCursor}
                                                onClick={() => {
                                                    this.setState({ student: el, showConnect: true });
                                                    localStorage.setItem('student', JSON.stringify(el));
                                                }}
                                            >
                                                <Table.Cell verticalAlign="middle">
                                                    {el.lastName} {el.firstName}  {el.locked === 1 ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null}
                                                    {el.studyProgramStudentSwitchedToId !== null ? <span style={{ float: 'right' }}>  <Icon name="check" color="blue" /></span> : null}
                                                    {el.dateOfAbandonment !== null ? <span style={{ float: 'right' }}>  <Icon name="sign-out" color="red" /></span> : null}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" width={4}>
                                                    {el.index}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                                </Table.Cell>
                                            </Table.Row>}
                                            content="Prikaz informacija o prelasku"
                                            hideOnScroll
                                            position="left center"
                                        />))}
                                    </Table.Body>
                                </Table>
                                </div>
                                    : <div> Nema studenta. </div>
                            : <Fragment />
                        }
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}


export default FilterStudent;



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/FilterStudent.js